import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import {
  BestScores,
  CasualTournamentDetails,
  EventSchedule,
  PrizeDetails,
} from '@fantaz/shared/data-access/models';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { GamesUiGameDetailsModule } from '@fantaz/shared/ui/game-details';
import { SharedUiTableComponentModule } from '@fantaz/shared/ui/table-component';
import { TournamentsUiScoreSummaryModule } from '@fantaz/tournaments/ui/score-summary';

import { TournamentPrizeDetails } from '../prize-details/prize-details.component';

@Component({
  selector: 'fz-tab-tournament-details',
  standalone: true,
  imports: [
    TournamentsUiScoreSummaryModule,
    MatCardModule,
    CurrencyModule,
    MatIconModule,
    GamesUiGameDetailsModule,
    SharedUiTableComponentModule,
    TournamentPrizeDetails,
  ],
  templateUrl: './tournament-details.html',
  styleUrls: ['./tournament-details.scss'],
})
export class TournamentDetails {
  @Input() eventScheduleDetails: EventSchedule | null | undefined;
  @Input() tournamentPrizeValue: string | null | undefined | string[];
  @Input() eventRating: number | undefined;
  @Input() eventCode?: string;
  @Input() bestScores?: BestScores | undefined;
  @Input() prizeImage: string | undefined;
  @Input() isLEP: boolean | undefined;
  @Input() eventPrototypeUuid: string | undefined;
  @Input() casualGameStartTime: string | undefined;
  @Input() casualGameEndTime: string | undefined;
  @Input() showSummary: boolean;
  @Input() details?: CasualTournamentDetails | null | undefined;
  @Input() assetUrl?: string;

  @Output() share: EventEmitter<void> = new EventEmitter();
  @Output() playGame: EventEmitter<void> = new EventEmitter();
  @Output() tryForFree: EventEmitter<void> = new EventEmitter();

  /**
   * Play control for the tournament
   */
  @Input()
  playControls: TemplateRef<any>;

  get prizeImageFullSize() {
    if (
      typeof this.eventScheduleDetails?.firstPrize?.prizeImageFullSize ===
      'string'
    ) {
      return this.eventScheduleDetails?.firstPrize?.prizeImageFullSize;
    }
    return this.eventScheduleDetails?.firstPrize?.prizeImageFullSize?.url;
  }

  onShare() {
    this.share.emit();
  }
  onPlay() {
    this.playGame.emit();
  }
  onTryForFree() {
    this.tryForFree.emit();
  }

  inTheFuture() {
    if (this.casualGameStartTime) {
      return (
        new Date(this.casualGameStartTime).getTime() > new Date().getTime()
      );
    }
    return false;
  }
  showListPrizes() {
    return (
      this.eventScheduleDetails?.prizeDetails &&
      this.eventScheduleDetails?.prizeDetails.length > 1
    );
  }

  getOrderedPrizeDetails() {
    const prizeDetails = [...(this.eventScheduleDetails?.prizeDetails || [])];
    return prizeDetails.sort(
      (a: PrizeDetails, b: PrizeDetails) => Number(a.rank) - Number(b.rank),
    );
  }
}
